// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1U1JK","type":"styles_type__1B52a","choices":"styles_choices__1WlG2"};